import { Gift, Share2, ArrowRight, Copy, Check } from "lucide-react";
import { useState } from "react";

const ReferralSection = () => {
  const [copied, setCopied] = useState(false);

  const referralMessage = "Hey! I found BrandBorn - India's #1 marketplace onboarding agency. They launch brands on Myntra, Nykaa, Ajio, Blinkit in just 14 days. Use my referral and get Rs 5,000 cashback! Visit www.brandborn.in or call +91-9464645491";

  const handleCopy = () => {
    navigator.clipboard.writeText(referralMessage);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  const handleWhatsAppShare = () => {
    navigator.clipboard.writeText(referralMessage).then(() => {
      alert("Referral message copied! Now open WhatsApp and paste it to your friend.");
    });
  };

  return (
    <section id="referral-section" className="py-16 md:py-20 px-4 bg-black relative overflow-hidden" data-testid="referral-section">
      {/* Background pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-10 left-10 w-32 h-32 border-2 border-white rounded-full" />
        <div className="absolute bottom-10 right-10 w-48 h-48 border-2 border-white rounded-full" />
        <div className="absolute top-1/2 left-1/3 w-20 h-20 border-2 border-white rounded-full" />
      </div>

      <div className="max-w-5xl mx-auto relative z-10 text-center">
        <div className="inline-flex items-center gap-2 px-5 py-2 bg-red-600 text-white rounded-lg text-sm font-bold mb-6">
          <Gift size={16} />
          <span>REFER & EARN PROGRAM</span>
        </div>

        <h2 className="text-3xl md:text-4xl lg:text-5xl font-black text-white mb-4 leading-tight">
          Refer a Friend & Get{" "}
          <span className="inline-block bg-red-600 text-white px-4 py-1 rounded-lg transform -rotate-1">
            &#8377;5,000
          </span>{" "}
          Cashback
        </h2>

        <p className="text-lg md:text-xl text-white/90 mb-8 max-w-2xl mx-auto">
          Know a brand that needs marketplace onboarding? Refer them to BrandBorn. When they sign up, you get <strong>&#8377;5,000 cashback</strong> directly in your account!
        </p>

        {/* How it works */}
        <div className="grid md:grid-cols-3 gap-6 mb-10 max-w-3xl mx-auto">
          <div className="bg-white/10 rounded-xl p-5 border border-white/10">
            <div className="w-10 h-10 bg-red-600 text-white rounded-lg flex items-center justify-center font-black text-lg mx-auto mb-3">1</div>
            <h3 className="text-white font-bold mb-1">Share Referral</h3>
            <p className="text-white/70 text-sm">Share BrandBorn with a friend who wants to sell online</p>
          </div>
          <div className="bg-white/10 rounded-xl p-5 border border-white/10">
            <div className="w-10 h-10 bg-red-600 text-white rounded-lg flex items-center justify-center font-black text-lg mx-auto mb-3">2</div>
            <h3 className="text-white font-bold mb-1">They Sign Up</h3>
            <p className="text-white/70 text-sm">Your friend signs up for any onboarding plan</p>
          </div>
          <div className="bg-white/10 rounded-xl p-5 border border-white/10">
            <div className="w-10 h-10 bg-red-600 text-white rounded-lg flex items-center justify-center font-black text-lg mx-auto mb-3">3</div>
            <h3 className="text-white font-bold mb-1">Get &#8377;5,000</h3>
            <p className="text-white/70 text-sm">Receive cashback once their onboarding starts</p>
          </div>
        </div>

        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <button
            onClick={handleWhatsAppShare}
            className="flex items-center gap-2 px-8 py-4 bg-red-600 text-white rounded-xl font-bold text-lg hover:bg-red-700 transition-all"
            data-testid="referral-whatsapp-share"
          >
            <Share2 size={20} />
            Share on WhatsApp
          </button>
          <button
            onClick={handleCopy}
            className="flex items-center gap-2 px-8 py-4 bg-white/10 border-2 border-white/30 text-white rounded-xl font-bold text-lg hover:bg-white/20 transition-all"
            data-testid="referral-copy-link"
          >
            {copied ? <Check size={20} /> : <Copy size={20} />}
            {copied ? "Copied!" : "Copy Referral Message"}
          </button>
        </div>

        <p className="text-white/60 text-xs mt-6">
          *Cashback applicable on successful onboarding. No limit on referrals. T&C apply.
        </p>
      </div>
    </section>
  );
};

export default ReferralSection;
